

export const normalizeText = (value) => (value || "").toString().trim();

export const normalizeDigits = (value) => (value || "").toString().replace(/\D/g, "");

export const normalizePassport = (value) =>
  normalizeText(value).replace(/[^a-z0-9]/gi, "").toUpperCase();

export const buildUsernamePreview = (firstName, lastName, identification) =>
  `${normalizeText(firstName).toLowerCase().slice(0, 2)}${normalizeText(lastName)
    .toLowerCase()
    .slice(0, 2)}${normalizeText(identification).replace(/[-]/g, "").slice(-5)}`;

export const normalizeDocumentByType = (value, documentType) => {
  const normalizedType = normalizeText(documentType).toUpperCase();
  if (normalizedType === "CEDULA" || normalizedType === "RNC") {
    return normalizeDigits(value);
  }

  if (normalizedType === "IDENTIFICACION") {
    return normalizeText(value).toUpperCase();
  }

  return normalizePassport(value);
};

export const formatCedula = (value) => {
  const digits = normalizeDigits(value).slice(0, 11);
  if (digits.length <= 3) {
    return digits;
  }
  if (digits.length <= 10) {
    return `${digits.slice(0, 3)}-${digits.slice(3)}`;
  }

  return `${digits.slice(0, 3)}-${digits.slice(3, 10)}-${digits.slice(10, 11)}`;
};

export const formatRnc = (value) => {
  const digits = normalizeDigits(value).slice(0, 9);
  if (digits.length <= 1) {
    return digits;
  }
  if (digits.length <= 3) {
    return `${digits.slice(0, 1)}-${digits.slice(1)}`;
  }
  if (digits.length <= 8) {
    return `${digits.slice(0, 1)}-${digits.slice(1, 3)}-${digits.slice(3)}`;
  }

  return `${digits.slice(0, 1)}-${digits.slice(1, 3)}-${digits.slice(3, 8)}-${digits.slice(8, 9)}`;
};

export const getDocumentValidationMessage = (
  documentType,
  documentNumber,
  options = {},
) => {
  const normalizedType = normalizeText(documentType).toUpperCase();
  const normalizedDocument = normalizeDocumentByType(documentNumber, normalizedType);

  if (!normalizedDocument) {
    return "Debe indicar un número de documento para validar.";
  }

  if (options.skipFormatValidation || normalizedType === "IDENTIFICACION") {
    return "";
  }

  if (normalizedType === "CEDULA" && normalizedDocument.length !== 11) {
    return "La cédula debe contener 11 digitos.";
  }

  if (normalizedType === "RNC" && normalizedDocument.length !== 9) {
    return "El RNC debe contener 9 digitos.";
  }

  if (
    normalizedType === "PASAPORTE" &&
    !/^[A-Z0-9]{6,20}$/i.test(normalizedDocument)
  ) {
    return "El pasaporte debe ser alfanumerico y tener entre 6 y 20 caracteres.";
  }

  return "";
};
